import { Popconfirm , Button } from "antd";
import { DeleteOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import apiAction from "../../ajax/service";
import { useDispatch, useSelector } from "react-redux";
import { clearAgreementInfo, clearEventsInfo, clearRentInfo } from "../../features/rentSlice";
import { loadRentalInfo, loadRentals } from "../../interfaces/rentInterface";
import { loadEvents } from "../../interfaces/eventInterface";


const DeleteWithPopup = ({ modal, id, wrap=false}) => {
  const dispatch = useDispatch();
  const [openPopup, setOpenPopup] = useState(false);
  const rentalFilters = useSelector(state=>state.rent.rentalFilters)
  const eventFilters = useSelector(state=>state.rent.eventFilters)
  const onDeleteConfirm = () => {
    apiAction("forms", { id , modal }, "delete").then(() => {
      switch (modal) {
        case "rental":
          dispatch(clearRentInfo());
          loadRentals(dispatch,
            undefined,
            undefined,
            undefined,
            undefined,
            rentalFilters
          )
          break;
        case "rentalAgreement":
          dispatch(clearAgreementInfo());
          break;
        case "event":
          dispatch(clearEventsInfo());
          loadEvents(dispatch,
            undefined,
            undefined,
            undefined,
            eventFilters
          )
          break;
      }
    });
  };
  return (
    <Popconfirm
      open={openPopup}
      onCancel={() => setOpenPopup(false)}
      icon={<QuestionCircleOutlined style={{ color: "red" }} />}
      placement="top"
      title={"Warning "}
      description={"Sure you wanted to delete ?"}
      okText={"Delete"}
      okType="danger"
      onConfirm={onDeleteConfirm}
    >
      {wrap ? (
        <Button style={wrap} onClick={() => setOpenPopup(true)} key={"delete"}>

          <DeleteOutlined />
          Delete
        </Button>
      ) : (
        <DeleteOutlined onClick={() => setOpenPopup(true)} key={"delete"} />
      )}
    </Popconfirm>
  );
};

export default DeleteWithPopup;
